import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Icon from './Icon';
import { Link } from 'react-router-dom';
import CardsBranches from './CardsBranches';
import CardsAssistant from './CardsAssistant';
import CardsPods from './CardsPods';


const PodMemberCard = ({ data, heading, initialSection = 'branches' }) => {
  const [activeSection, setActiveSection] = useState(initialSection);

  const branchesCount = data?.branches ? String(data.branches.length).padStart(2,'0') : '0';
  const assistantsCount = data?.assistants ? String(data.assistants.length).padStart(2,'0') : '0';
  const podsCount = data?.pods ? String(data.pods.length).padStart(2,'0') : '0';

  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const phone = data?.phone;
  const email = data?.email;

  return (
    <div className="p-24 rounded-16 app-shadow-sm bg-brand-light mb-24 card-managers">
      {/* Manager header: avatar, name, contact */}
      <div className="mb-16">
        <div className="d-flex align-items-center mb-12 header">
          <div className="avatar-pill me-7"><span className="text-12 fw-700 text-navy">{getInitials(heading)}</span></div>
          <h6 className="text-16 fw-700 text-navy mb-0">{heading}</h6>
        </div>
        <div className="d-flex align-items-center contact-item">
          {phone &&(<>
            <a href={`tel:${phone}`}>
              <div className="d-flex align-items-center contact-item">
                <img src="/assets/icons/phone.svg" alt="Phone" className="me-6" width="14" height="13" />
                <span className="text-14 fw-500 text-navy">{phone}</span>
              </div>
            </a>
            <span className="mx-3"></span> 
          </>)}
          <a href={`mailto:${email}`}>
            <div className="d-flex align-items-center contact-item">
                <img src="/assets/icons/email.svg" alt="Email" className="me-6" width="14" height="14" />
                <span className="text-14 fw-500 text-navy">{email}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PodMemberCard;
